import React from 'react'
import { IonPage, IonHeader, IonToolbar, IonButtons, IonButton, IonIcon, IonTitle, IonContent } from '@ionic/react'
import { chevronBack } from 'ionicons/icons'
import { BaseSyntheticEvent } from 'react'
import { useTranslation } from 'react-i18next'
import PatientMedicalHistoryContent from '../patientMedicalHistoryContent/PatientMedicalContent.component'
import PCRHeader from '../../../components/pcrHeader/PCRHeader.component'
import { useHistory } from 'react-router'
import { TabConstants } from '../../../components/tabs/Tabs.constants'

const PatientMedicalHistory: React.FC = () => {
  const { t } = useTranslation()
  const history = useHistory()

  const onBackClick = (e: BaseSyntheticEvent) => {
    e.preventDefault()
    history.push(TabConstants.PATIENT_INFO_ROUTE)
  }

  return (
    <IonPage id='PatientMedicalHistory'>
      <PCRHeader />
      <IonHeader>
        <IonToolbar color='light'>
          <IonButtons slot='start'>
            <IonButton data-testid='Back' color='primary-alt' onClick={onBackClick}>
              <IonIcon icon={chevronBack} />
              {t('common.buttons.Back')}
            </IonButton>
          </IonButtons>
          <IonTitle data-testid='HeaderTitle'>{t('patientMedicalHistory.Title')}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent color='light' fullscreen>
        <PatientMedicalHistoryContent />
      </IonContent>
    </IonPage>
  )
}

export default PatientMedicalHistory
